import { Component, Input } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { SearchResultFaq } from '@core/models/domains/hotel';

@Component({
  selector: 'iho-plp-faq',
  standalone: true,
  imports: [NgIf, NgFor],
  templateUrl: './plp-faq.component.html',
  styleUrls: ['./plp-faq.component.scss'],
})
export class PlpFaqComponent {
  @Input() dataSource: SearchResultFaq[] = new Array<SearchResultFaq>
  showCollapseInfo = false;

}
